import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationService } from '../../../services/navigation/navigation.service';

@Component({
    selector: 'app-data-transform-config-layout',
    templateUrl: './data-transform-config-layout.component.html',
    styleUrls: ['./data-transform-config-layout.component.css'],
    standalone: false
})
export class DataTransformConfigLayoutComponent implements OnInit, AfterViewInit {

  constructor(private navigationService: NavigationService) {}

  @ViewChild('drawer') drawer: MatDrawer;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.navigationService.setConfigLayoutLeftDrawer(this.drawer);
  }
}
